export const PAGES_WITHOUT_TRIAL_HEADER = [
    'login',
    'onboarding',
    'survey',
    'welcome',
    'logout',
    'start',
    'checkout',
    'admin',
    'pricing',
    'test-embed',
] as const;

export const PARENT_PAGES_WITHOUT_TRIAL_HEADER = [
    'survey',
    'admin',
    'embed',
] as const;

export const TRIAL_CREDITS = 250;
export const TRIAL_CREDITS_LABEL = TRIAL_CREDITS.toLocaleString('en-US');
export const TRIAL_VERIFIED_EMAILS = 1000;
export const TRIAL_VERIFIED_EMAILS_LABEL = TRIAL_VERIFIED_EMAILS.toLocaleString('en-US');

export const TRIAL_FEATURES = [
    { label: 'Multi Signal Deal Opportunity Score' },
    { label: 'Pipeline AI Recommendation Engine' },
    { label: 'ICP Stakeholders mapping' },
    { label: 'Human-Verified Buyer Insights' },
    { label: `${TRIAL_VERIFIED_EMAILS_LABEL} free verified emails + Phones of your ICP` },
    { label: 'MCP connectivity for any LLM', isNew: true },
] as const;

export const ABOUT_TRIAL_DISMISSED_KEY = 'clearitty_about_trial_dismissed';
export const TRIAL_JUST_ACTIVATED_KEY = 'clearitty_trial_just_activated';
export const TRY_TRIAL_DISMISSED_KEY = 'clearitty_try_trial_dismissed';
export const TRIAL_ENDED_DISMISSED_KEY = 'clearitty_trial_ended_dismissed';
export const TRIAL_INFO_DISMISSED_KEY = 'clearitty_trial_info_dismissed';
export const TRIAL_HEADER_DISMISSED_KEY = 'clearitty_trial_header_dismissed';
